import gql from 'graphql-tag';

export type AmazonBillingAgreementMutationInput = {
  data: {
    id: string;
    type: 'billing_agreement';
    attributes: {
      billing_agreement_id: string;
      country_code: string;
    };
  };
};

export type AmazonBillingAgreementMutationVariables = {
  input: AmazonBillingAgreementMutationInput;
};

export type AmazonBillingAgreementMutation = {
  createBillingAgreement: {
    __typename: 'RestCreateBillingAgreement';
  };
};

export const AMAZON_BILLING_AGREEMENT_MUTATION = gql`
  mutation AmazonBillingAgreementMutation($input: AmazonBillingAgreementMutationInput) {
    createBillingAgreement(input: $input)
    @rest(
      type: "RestCreateBillingAgreement"
      endpoint: "cart"
      path: "/v3.5/billing_agreement"
      method: "POST"
    ) {
      NoResponse
    }
  }
`;
